// heading fade-in animations
function runTextAnimations(screen) {
	const container = document.querySelector(`.js-screen[data-screen="${screen}"]`);

	if (!container) {
		console.error('No screen exists with name: ' + screen);
		return;
	}

	const texts = container.querySelectorAll('.js-animate-text');
	texts.forEach((el) => el.classList.add('is-active'));
}

export default runTextAnimations;
